<template>
  <div v-if="$store.getters.isLoaded(['shelves'])">
    <h4 class="headline d-flex justify-content-between">
      <div>
        Shelfspace
        <ShelfBadge :label="$route.params.shelfSpaceId" />
      </div>
      <div>
        <span class="reserve-batch" v-if="space.reserve">RESERVE</span>
        <DotMenu>
          <li @click="toggleReserveShelf">{{ space.reserve ? 'Use as regular shelf' : 'User as reserve shelf' }}</li>
        </DotMenu>
      </div>
    </h4>
    <ProductsListing
      :items="items"
      @item-selected="openEditStockLayer"
      :showAddOptions="true"
      @add-option="showAddStockLayer = true"
    />
    <AddStockLayer
      v-if="showAddStockLayer"
      :initialShelfSpaceId="$route.params.shelfSpaceId"
      @close="showAddStockLayer = false"
    />
    <EditStockLayer
      v-if="editStockLayerProduct && editStockLayerProductId"
      :product="editStockLayerProduct"
      :productId="editStockLayerProductId"
      :shelfSpaceId="$route.params.shelfSpaceId"
      openLink="product"
      @close="closeEditStockLayer"
    />
    <Scanner v-if="!editStockLayerProductId && !showAddStockLayer" />
  </div>
</template>

<script>
import Scanner from '@/components/Scanner'
import ShelfBadge from '@/components/ShelfBadge'
import ProductsListing from '@/components/ProductsListing'
import AddStockLayer from '@/components/Stock/AddStockLayer'
import EditStockLayer from '@/components/Stock/EditStockLayer'
import DotMenu from '@/shared/DotMenu'
import { db } from '@/shared/firebase'

export default {
  components: { Scanner, ShelfBadge, ProductsListing, AddStockLayer, EditStockLayer, DotMenu },
  data() {
    return {
      showAddStockLayer: false,
      editStockLayerProduct: null,
      editStockLayerProductId: null
    }
  },
  computed: {
    shelfId() {
      return this.$route.params.shelfSpaceId.split('-')[0]
    },
    spaceId() {
      return this.$route.params.shelfSpaceId.split('-')[1]
    },
    shelf() {
      return _.find(this.$store.state.shelves, { id: this.shelfId })
    },
    space() {
      return this.shelf.spaces[this.spaceId]
    },
    items() {
      return this.space ? this.space.items : []
    }
  },
  methods: {
    openEditStockLayer(item) {
      this.editStockLayerProduct = _.find(this.$store.state.products, { id: item.productId })
      this.editStockLayerProductId = item.productId
    },
    closeEditStockLayer() {
      this.editStockLayerProduct = null
      this.editStockLayerProductId = null
    },
    toggleReserveShelf() {
      db.doc(`/private/warehouse/shelves/${this.shelfId}`).update({
        [`spaces.${this.spaceId}.reserve`]: !this.space.reserve
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reserve-batch {
  display: inline-block;
  padding: 0.125em 0.5em;

  background: #777;
  border-radius: 3px;

  color: #fff;
  font-size: 0.7em;
}
</style>
